"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidPingType = exports.BLETemperatureErrorStatus = exports.CrashDetection = exports.ioIdLabelMapString = exports.ioIdLabelMap = exports.SpeedThreshold = exports.FuelType = exports.TeltonicaAnalogIoId = exports.AnalogValueType = exports.ReportFormat = exports.MewpReportType = exports.FuelEventType = exports.ViolationType = exports.DefaultEngineStroke = exports.MeterSource = void 0;
var MeterSource;
(function (MeterSource) {
    MeterSource["Can"] = "can";
    MeterSource["Telematics"] = "telematics";
})(MeterSource = exports.MeterSource || (exports.MeterSource = {}));
exports.DefaultEngineStroke = 2;
var ViolationType;
(function (ViolationType) {
    ViolationType["GeoIn"] = "geo-in";
    ViolationType["GeoOut"] = "geo-out";
    ViolationType["Overspeed"] = "overspeed";
    ViolationType["Idling"] = "idling";
    ViolationType["HarshAcceleration"] = "harsh-acceleration";
    ViolationType["HarshBreaking"] = "harsh-breaking";
    ViolationType["HarshCornering"] = "harsh-cornering";
    ViolationType["EngineTemperature"] = "engine-temperature";
    ViolationType["Fuel"] = "fuel";
    ViolationType["BatteryVoltage"] = "battery-voltage";
    ViolationType["EngineRPM"] = "engine-rpm";
    ViolationType["Proximity"] = "proximity-warning";
    ViolationType["RestrictedGeofenceEntry"] = "restricted-geofence-entry";
    ViolationType["RestrictedGeofenceExit"] = "restricted-geofence-exit";
})(ViolationType = exports.ViolationType || (exports.ViolationType = {}));
var FuelEventType;
(function (FuelEventType) {
    FuelEventType["Refill"] = "Refill";
    FuelEventType["Theft"] = "Theft";
})(FuelEventType = exports.FuelEventType || (exports.FuelEventType = {}));
var MewpReportType;
(function (MewpReportType) {
    MewpReportType["Yard"] = "yard-report";
    MewpReportType["MobileCrane"] = "mobile-crane-report";
    MewpReportType["BoomLift"] = "boom-lift-report";
    MewpReportType["SpiderCrane"] = "spider-crane-report";
    MewpReportType["SpiderLift"] = "spider-lift-report";
    MewpReportType["BoomLoader"] = "boom-loader-report";
    MewpReportType["ManLift"] = "man-lift-report";
    MewpReportType["CrawlerCrane"] = "crawler-crane-report";
    MewpReportType["MobileTireCrane"] = "mobile-crane-report";
    MewpReportType["SkidSteer"] = "skid-steer-report";
    MewpReportType["BackhoeLoader"] = "backhoe-loader-report";
    MewpReportType["TowerCrane"] = "tower-crane-report";
    MewpReportType["BitumenTanker"] = "bitumen-tanker-report";
    MewpReportType["ScissorLift"] = "scissor-lift-report";
    MewpReportType["Truck"] = "trucks-report";
    MewpReportType["Bus"] = "bus-report";
    MewpReportType["WaterTanker"] = "water-tanker-report";
    MewpReportType["PickTruck"] = "pickup-report";
    MewpReportType["DieselTanker"] = "diesel-tanker-report";
    MewpReportType["Lowbed"] = "lowbed-report";
    MewpReportType["CementMixer"] = "cement-mixer-report";
    MewpReportType["AsphaltPaver"] = "asphalt-paver-report";
    MewpReportType["WheelLoader"] = "wheel-loader-report";
    MewpReportType["RoughTerrainCrane"] = "rough-terrain-crane-report";
})(MewpReportType = exports.MewpReportType || (exports.MewpReportType = {}));
var ReportFormat;
(function (ReportFormat) {
    ReportFormat["Csv"] = "csv";
    ReportFormat["Excel"] = "excel";
    ReportFormat["Pdf"] = "pdf";
})(ReportFormat = exports.ReportFormat || (exports.ReportFormat = {}));
var AnalogValueType;
(function (AnalogValueType) {
    AnalogValueType["FuelLevel"] = "fuel_level";
    AnalogValueType["AxleLoad"] = "axle_load";
    AnalogValueType["BoomVerticalActivated"] = "boom_vertical_activated";
    AnalogValueType["SprayActivated"] = "spray_activated";
    AnalogValueType["ShovelActivated"] = "shovel_activated";
    AnalogValueType["DumpTruckActivated"] = "dump_truck_activated";
    AnalogValueType["CementMixingActivated"] = "cement_mixing_activated";
    AnalogValueType["CementUnloadingActivated"] = "cement_unloading_activated";
    AnalogValueType["AugerActivated"] = "auger_activated";
    AnalogValueType["WinchActivated"] = "winch_activated";
    AnalogValueType["SwingLeftActivated"] = "swing_left_activated";
    AnalogValueType["SwingRightActivated"] = "swing_right_activated";
    AnalogValueType["TrolleyInActivated"] = "trolley_in_activated";
    AnalogValueType["TrolleyOutActivated"] = "trolley_out_activated";
    AnalogValueType["RemoteCutOffRelay"] = "remote_cut_off_relay";
    AnalogValueType["WeightActivated"] = "weight_activated_value";
    AnalogValueType["ArcingSensorActivated"] = "arcing_activated";
    AnalogValueType["LoadDetectionActivated"] = "load_detection_activated";
    AnalogValueType["PressureActivated"] = "pressure_activated";
    AnalogValueType["EngineRPM"] = "engine_rpm";
    AnalogValueType["PWASSensor"] = "pwas_sensor";
    AnalogValueType["HammeringActivated"] = "hammering_activated";
    AnalogValueType["BladeActivated"] = "blade_activated";
    AnalogValueType["PilingRotarySensorActivated"] = "piling_rotary_sensor_activated";
    AnalogValueType["PilingRCDSensorActivated"] = "piling_rcd_sensor_activated";
    AnalogValueType["CraneSensorActivated"] = "crane_sensor_activated";
    AnalogValueType["DozerSensorActivated"] = "dozer_sensor_activated";
    AnalogValueType["MobileCraneSensorActivated"] = "mobile_crane_sensor_activated";
    AnalogValueType["CompactingSensorActivated"] = "compacting_sensor_activated";
    AnalogValueType["DumpTruckAxleLoadActivated"] = "dump_truck_axle_load_activated";
    AnalogValueType["CompressorActuatorActivated"] = "compressor_actuator_activated";
    AnalogValueType["CompressorPressureSensorActivated"] = "compressor_pressure_sensor_activated";
    AnalogValueType["ShovelUtilisationActivated"] = "shovel_utilisation_activated";
    AnalogValueType["RoughTerrainSensorActivated"] = "rough_terrain_activated";
    AnalogValueType["JoyStickMovementActivated"] = "joystick_movement_activated";
    AnalogValueType["ParkBreakLeverActivated"] = "park_break_lever_activated";
    AnalogValueType["ElevationActivated"] = "elevation_activated";
    AnalogValueType["GeneratorLoadActivated"] = "generator_load_activated";
})(AnalogValueType = exports.AnalogValueType || (exports.AnalogValueType = {}));
var TeltonicaAnalogIoId;
(function (TeltonicaAnalogIoId) {
    TeltonicaAnalogIoId[TeltonicaAnalogIoId["AnalogInput1"] = 9] = "AnalogInput1";
    TeltonicaAnalogIoId[TeltonicaAnalogIoId["AnalogInput2"] = 6] = "AnalogInput2";
    TeltonicaAnalogIoId[TeltonicaAnalogIoId["AnalogInput3"] = 10] = "AnalogInput3";
    TeltonicaAnalogIoId[TeltonicaAnalogIoId["AnalogInput4"] = 11] = "AnalogInput4";
    TeltonicaAnalogIoId[TeltonicaAnalogIoId["AnalogOutput1"] = 12] = "AnalogOutput1";
    TeltonicaAnalogIoId[TeltonicaAnalogIoId["BleFuelFrequency1"] = 13] = "BleFuelFrequency1";
})(TeltonicaAnalogIoId = exports.TeltonicaAnalogIoId || (exports.TeltonicaAnalogIoId = {}));
var FuelType;
(function (FuelType) {
    FuelType["Petrol"] = "Petrol";
    FuelType["Diesel"] = "Diesel";
})(FuelType = exports.FuelType || (exports.FuelType = {}));
exports.SpeedThreshold = 5;
exports.ioIdLabelMap = {
    [TeltonicaAnalogIoId.AnalogInput1]: 'analog_1',
    [TeltonicaAnalogIoId.AnalogInput2]: 'analog_2',
    [TeltonicaAnalogIoId.AnalogInput3]: 'analog_3',
    [TeltonicaAnalogIoId.AnalogInput4]: 'analog_4',
};
exports.ioIdLabelMapString = {
    [TeltonicaAnalogIoId.AnalogInput1]: 'Analog Input 1',
    [TeltonicaAnalogIoId.AnalogInput2]: 'Analog Input 2',
    [TeltonicaAnalogIoId.AnalogInput3]: 'Analog Input 3',
    [TeltonicaAnalogIoId.AnalogInput4]: 'Analog Input 4',
    [TeltonicaAnalogIoId.AnalogOutput1]: 'Analog Output 1',
    [TeltonicaAnalogIoId.BleFuelFrequency1]: 'Ble Frequency 1',
};
var CrashDetection;
(function (CrashDetection) {
    CrashDetection["REAL_CRASH_DETECTED_DEVICE_IS_CALIBRATED"] = "real_crash_detected_device_is_calibrated";
    CrashDetection["LIMITED_CRASH_TRACE_DEVICE_NOT_CALIBRATED"] = "limited_crash_trace_device_not_calibrated";
    CrashDetection["LIMITED_CRASH_TRACE_DEVICE_IS_CALIBRATED"] = "limited_crash_trace_device_is_calibrated";
    CrashDetection["FULL_CRASH_TRACE_DEVICE_NOT_CALIBRATED"] = "full_crash_trace_device_not_calibrated";
    CrashDetection["FULL_CRASH_TRACE_DEVICE_IS_CALIBRATED"] = "full_crash_trace_device_is_calibrated";
    CrashDetection["REAL_CRASH_DETECTED_DEVICE_NOT_CALIBRATED"] = "real_crash_detected_device_not_calibrated";
    CrashDetection["FAKE_CRASH_DETECTED_DEVICE_CALIBRATED_POTHOLE"] = "fake_crash_detected_device_calibrated_pothole";
    CrashDetection["FAKE_CRASH_DETECTED_DEVICE_CALIBRATED_SPEED_CHECK"] = "fake_crash_detected_device_calibrated_speed_check";
})(CrashDetection = exports.CrashDetection || (exports.CrashDetection = {}));
var BLETemperatureErrorStatus;
(function (BLETemperatureErrorStatus) {
    BLETemperatureErrorStatus["ABNORMAL_SENSOR_STATE_1"] = "abnormal sensor state";
    BLETemperatureErrorStatus["SENSOR_NOT_FOUND_1"] = "sensor not found";
    BLETemperatureErrorStatus["FAILED_SENSOR_DATA_PARSING_1"] = "failed sensor data parsing";
    BLETemperatureErrorStatus["SENSOR_NOT_FOUND_2"] = "sensor not found";
    BLETemperatureErrorStatus["FAILED_SENSOR_DATA_PARSING_2"] = "failed sensor data parsing";
    BLETemperatureErrorStatus["ABNORMAL_SENSOR_STATE_2"] = "abnormal sensor state";
})(BLETemperatureErrorStatus = exports.BLETemperatureErrorStatus || (exports.BLETemperatureErrorStatus = {}));
var InvalidPingType;
(function (InvalidPingType) {
    InvalidPingType["LOCATION"] = "LOCATION";
    InvalidPingType["FUTURE_DATE"] = "FUTURE_DATE";
})(InvalidPingType = exports.InvalidPingType || (exports.InvalidPingType = {}));
//# sourceMappingURL=Telematics.js.map